import StatScreen from "components/UI/statScreen/StatScreen";

function InfoTvStatPage() {
    return <StatScreen />;
}

export default InfoTvStatPage;